export const APP_ROUTES = {
  dashboard: "/",
  oauth: "/oauth",
  login: "/deprecated/login",
  resetPassword: "/reset-password",
  translations: "/translations",
  allGames: "/games/all-games",
  providers: "/games/providers",
  categories: "/games/categories",
  showGame: "/games/show/:id",
  terms: "/content/terms",
  banners: "/content/banners",
  faqs: "/content/faqs",
  pages: "/content/pages",
  news: "/content/news",
  imagesPack: "/content/images-pack",
  fileStorage: "/content/file-storage",
  appManagement: "/content/app-management",
  promotions: "/promotions",
  calendars: "/promotions/calendars",
  tournaments: "/promotions/tournaments",
  showCalendar: "/promotions/calendars/:slug",
  gamification: "/gamification",
  pointGames: "/gamification/:gamificationId",
  level: "/gamification/:gamificationId/point-games/:pointGameId",
  accounts: "/accounts",
  accountCreate: "/account/new",
  accountEdit: "/account/:id",
  roles: "/roles",
  actionLogs: "/action-logs",
  brands: "/brands",
  brandsCreate: "/brands/create",
  customers: "/customers",
  customerInfo: "/customers/:id",
  bonusRequest: "/bonus-request",
  gateways: "/integrations/gateways",
  services: "/integrations/services",
  deposit: "/payments/deposit",
  withdrawal: "/payments/withdrawal",
  paymentsCategories: "/payments/categories",
  quiz: "/quiz",
  bonusDistribution: "/bonus-distribution",
  notificationCampaigns: "/notification-campaigns",
  notificationCategories: "/notification-categories",
  referralProgram: "/referral-program",
};
